import { useParams } from "react-router-dom";
import BroadcasterViewDual from "./../components/BroadcasterViewDual.react";


export default function BroadcasterViewDualRoute(): React$Element<any> {
  let params = useParams();
  return <BroadcasterViewDual sessionId={params.sessionId} />;
}
